<template>
  <div class="page-container">

    
    <div class="main-content">
      <main class="content-area">
        <div class="content-header">
          <h2 class="content-title">{{ getCurrentSectionLabel() }}</h2>
        </div>
        
        <div v-if="guideContent" class="api-content">
          <div class="content-card">
            <h3 class="content-title">{{ guideTitle || '女生报考专项指南' }}</h3>
            <div class="content-body" v-html="guideContent"></div>
          </div>
        </div>
        
        <div v-else class="guide-content">
          <div 
            v-for="(item, index) in filteredContent" 
            :key="index"
            class="guide-card"
          >
            <div class="card-header">
              <span class="card-badge">{{ item.category }}</span>
              <h3 class="card-title">{{ item.title }}</h3>
            </div>
            <div class="card-body">
              <p class="card-description">{{ item.content }}</p>
              <div v-if="item.points" class="card-points">
                <div v-for="(point, idx) in item.points" :key="idx" class="point-item">
                  <span class="point-icon">✓</span>
                  <span class="point-text">{{ point }}</span>
                </div>
              </div>
            </div>
            <div v-if="item.tips" class="card-tips">
              <span class="tips-label">💡 温馨提示</span>
              <p class="tips-content">{{ item.tips }}</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { getFemaleGuide } from "@/api/processApi";

export default {
  name: "FemaleApplicant",
  data() {
    return {
      currentSection: 'overview',
      sections: [
    
        { value: 'majors', label: '可选专业', icon: '📖' },
        { value: 'requirements', label: '报考条件', icon: '✅' },
        { value: 'advantages', label: '政策优势', icon: '⭐' }
      ],
      guideTitle: '',
      guideContent: '',
      defaultGuideData: {
        overview: [
          {
            category: '招生规模',
            title: '女生报考军校的招生情况',
            content: '近年来，军队院校女生招生规模逐年扩大，招生专业不断增加。女生报考军校已成为越来越多优秀女学生的选择。',
            points: [
              '2025年军队院校计划招收女生约2000人',
              '女生可报考的专业涵盖指挥类、技术类、医学类等多个领域',
              '部分军事指挥专业开始招收女生，打破了传统限制',
              '女生在军校中享有与男生同等的学习和发展机会'
            ],
            tips: '女生报考军校需提前了解各院校的招生计划，选择适合自己的专业。'
          },
          {
            category: '发展前景',
            title: '女生在军队中的发展机会',
            content: '女军官在军队中拥有广阔的发展空间，可以在多个领域发挥才能，实现个人价值。',
            points: [
              '专业技术岗位：从事通信、医疗、科研等技术工作',
              '管理岗位：担任机关、院校等管理职务',
              '教学岗位：在军事院校担任教员',
              '晋升通道：与男军官享有同等的晋升机会'
            ],
            tips: '建议女生根据自己的兴趣和特长，选择适合的发展方向。'
          }
        ],
        majors: [
          {
            category: '技术类',
            title: '专业技术专业',
            content: '技术类专业培养专业技术人才，毕业后主要从事技术保障、科研等工作。',
            points: [
              '通信工程：从事通信系统维护和管理',
              '计算机科学：从事信息化建设和网络安全',
              '医学专业：从事军队医疗和卫生工作',
              '外语专业：从事翻译和对外交流工作'
            ],
            tips: '技术类专业对身体要求相对较低，适合女生报考。'
          },
          {
            category: '指挥类',
            title: '军事指挥专业',
            content: '部分指挥类专业开始招收女生，培养军事指挥人才。',
            points: [
              '部分院校的指挥专业对女生开放',
              '指挥类专业对身体和体能要求较高',
              '毕业后主要从事军事指挥和管理工作',
              '需要具备较强的领导能力和综合素质'
            ],
            tips: '报考指挥类专业前需详细了解具体的招生要求和体能标准。'
          },
          {
            category: '医学类',
            title: '医学相关专业',
            content: '军队医学院校为女生提供了丰富的医学专业选择。',
            points: [
              '临床医学：培养军医人才',
              '护理学：培养军队护理人员',
              '药学：从事药品研发和管理',
              '医学技术：从事检验、影像等技术工作'
            ],
            tips: '医学专业就业稳定，适合细心、有责任心的女生。'
          },
          {
            category: '文科类',
            title: '人文社科专业',
            content: '军队院校也开设了适合女生的文科类专业。',
            points: [
              '新闻学：从事军队新闻宣传工作',
              '法学：从事军队法律事务工作',
              '心理学：从事军队心理服务工作',
              '外语：从事翻译和国际交流工作'
            ],
            tips: '文科类专业对女生来说是比较好的选择。'
          }
        ],
        requirements: [
          {
            category: '基本条件',
            title: '报考基本要求',
            content: '女生报考军校需要满足以下基本条件。',
            points: [
              '年龄要求：不超过20周岁（截止当年8月31日）',
              '政治条件：必须通过政治考核，拥护党的基本路线',
              '学历要求：普通高中毕业生或同等学力',
              '成绩条件：高考成绩达到本省特殊类型招生控制线'
            ],
            tips: '具体要求请以当年招生简章为准。'
          },
          {
            category: '身体条件',
            title: '体检标准',
            content: '女生报考军校的体检标准与男生略有不同。',
            points: [
              '身高要求：不低于160cm',
              '视力要求：裸眼视力不低于4.5，矫正视力不低于4.9',
              '体重要求：符合标准体重范围',
              '其他要求：无传染性疾病、色盲色弱等'
            ],
            tips: '建议提前进行体检，了解自己的身体状况是否符合要求。'
          },
          {
            category: '体能测试',
            title: '体能要求',
            content: '女生需要通过体能测试，包括以下项目。',
            points: [
              '800米跑：测试耐力和速度',
              '立定跳远：测试下肢力量',
              '仰卧起坐：测试核心力量',
              '引体向上或屈臂悬垂：测试上肢力量'
            ],
            tips: '建议提前进行体能训练，提高体能测试成绩。'
          }
        ],
        advantages: [
          {
            category: '政策支持',
            title: '国家政策支持',
            content: '国家鼓励女生报考军校，提供了多项政策支持。',
            points: [
              '招生计划逐年增加，为女生提供更多机会',
              '部分专业对女生放宽录取条件',
              '提供专项奖学金和助学金',
              '毕业后享有军官待遇和保障'
            ],
            tips: '关注官方发布的最新招生政策，把握报考机会。'
          },
          {
            category: '就业保障',
            title: '就业前景',
            content: '女军官毕业后享有稳定的就业和良好的发展前景。',
            points: [
              '统一分配：根据专业和成绩确定分配去向',
              '军官待遇：享受工资、津贴、住房等保障',
              '职业发展：清晰的晋升通道和培训机会',
              '社会地位：作为国家公职人员享有较高荣誉'
            ],
            tips: '军校毕业是女生实现人生价值的重要途径。'
          },
          {
            category: '成长环境',
            title: '学习生活环境',
            content: '军校为女生提供了良好的学习和生活环境。',
            points: [
              '宿舍条件：提供舒适的住宿环境',
              '生活保障：完善的餐饮和医疗设施',
              '文体活动：丰富的课外活动和文化生活',
              '安全保障：严格的安保措施确保安全'
            ],
            tips: '军校生活虽然严格，但能培养独立和自律能力。'
          }
        ]
      }
    };
  },
  mounted() {
    this.fetchFemaleGuide();
  },
  computed: {
    filteredContent() {
      return this.defaultGuideData[this.currentSection] || [];
    }
  },
  methods: {
    fetchFemaleGuide() {
      getFemaleGuide().then(response => {
        if (response.data.code === 200) {
          const data = response.data.data;
          this.guideTitle = data.title || '女生报考专项指南';
          this.guideContent = data.pdfurl || '';
        }
      }).catch(error => {
        console.error('获取女生报考指南失败:', error);
      });
    },
    getCurrentSectionLabel() {
      const section = this.sections.find(s => s.value === this.currentSection);
      return section ? section.label : '';
    }
  }
};
</script>

<style scoped>
.page-container {
  margin-top: 60px;
  padding: 0 10px 10px;
  background: #f5f5f5;
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 24px;
  padding: 28px 20px;
  background: linear-gradient(135deg, #fff 0%, #fce4ec 50%, #f3e5f5 100%);
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(194, 24, 91, 0.12);
  border: 1px solid #f8bbd9;
}

.page-title {
  font-size: 26px;
  color: #c2185b;
  margin: 0 0 12px 0;
  font-weight: 700;
  letter-spacing: 2px;
  text-shadow: 0 2px 8px rgba(194, 24, 91, 0.15);
}

.page-subtitle {
  font-size: 15px;
  color: #7b1fa2;
  margin: 0;
  font-weight: 500;
  letter-spacing: 1.5px;
}

.main-content {
  max-width: 1500px;
  margin: 0 auto;
}

.content-area {
  width: 100%;
}

/* .content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
} */

.content-title {
  font-size: 20px;
  margin: auto;

  color: #333;
  margin: 0;
  font-weight: 600;
}

.guide-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.guide-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s, box-shadow 0.2s;
}

.guide-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.card-badge {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 12px;
  background: #fce4ec;
  color: #c2185b;
  font-weight: 500;
}

.card-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.card-body {
  margin-bottom: 16px;
}

.card-description {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.card-points {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.point-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

.point-icon {
  color: #4caf50;
  font-weight: bold;
  flex-shrink: 0;
}

.point-text {
  flex: 1;
}

.card-tips {
  padding: 16px;
  background: #fff8e1;
  border-radius: 8px;
  border-left: 4px solid #ffc107;
}

.tips-label {
  font-size: 14px;
  color: #f57c00;
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
}

.tips-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 26px;
  }
  
  .content-title {
    font-size: 18px;
  }
}

.api-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.content-card .content-title {
  font-size: 25px;
  color: #333;
  margin: 0 0 16px 0;
  text-align: center;
  font-weight: 600;
}

.content-body {
  font-size: 15px;
  color: #333;
  line-height: 2;
  text-indent: 2em;
}

.content-body h4 {
  font-size: 20px;
  color: #c2185b;
  margin: 20px 0 16px 0;
  font-weight: bold;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #fce4ec;
}

.content-body p {
  margin: 0 0 16px 0;
  text-indent: 2em;
  line-height: 2;
}

.content-body ul, .content-body ol {
  margin: 0 0 12px 20px;
  padding: 0;
}

.content-body li {
  margin-bottom: 8px;
}
</style>